import { getBankFaviconAsSvg } from "../../utils/svgUtils";
import "./styles.scss";

const CurrentLinkedBankCard = ({
  heading,
  description,
  data,
  bankRowClassName,
}) => {
  return (
    <>
      <div className="current-linked-bank-card">
        <div className={`current-linked-bank-row ${bankRowClassName}`}>
          <div>
            <p className="connect-bank-heading">{heading}</p>
            <p className="connect-bank-description">{description}</p>
          </div>

          <div className="bank-logos">
            {data &&
              data.length > 0 &&
              data.map((bank, index) => {
                const favicon = getBankFaviconAsSvg(bank);
                if (favicon && index < 6) {
                  return (
                    <div className="bank-logo" key={bank}>
                      <img src={favicon} alt="bank1" />
                    </div>
                  );
                }
                return null;
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrentLinkedBankCard;
